import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { SubscriptionPlansProvider } from './contexts/SubscriptionPlansContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Games from './pages/Games';
import Leaderboard from './pages/Leaderboard';
import Profile from './pages/Profile';
import Subscription from './pages/Subscription';
import Analytics from './pages/Analytics';
import AdminDashboard from './pages/AdminDashboard';
import ServerManagement from './pages/ServerManagement';
import AuthCallback from './pages/AuthCallback';
import AdminRoute from './components/AdminRoute';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <AdminAuthProvider>
        <SocketProvider>
          <SubscriptionPlansProvider>
            <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/games" element={
              <ProtectedRoute>
                <Games />
              </ProtectedRoute>
            } />
            
            <Route path="/leaderboard" element={<Leaderboard />} />
            
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            
            <Route path="/subscription" element={
              <ProtectedRoute>
                <Subscription />
              </ProtectedRoute>
            } />
            
            <Route path="/analytics" element={
              <AdminRoute>
                <Analytics />
              </AdminRoute>
            } />
            
            <Route path="/servers" element={
              <ProtectedRoute>
                <ServerManagement />
              </ProtectedRoute>
            } />
            
            <Route path="/admin" element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } />
          </Routes>
          </Layout>
          </SubscriptionPlansProvider>
        </SocketProvider>
      </AdminAuthProvider>
    </AuthProvider>
  );
}

export default App;
